import CapsulasScreen from './containers/capsulasScreen'

export {default as CapsulasScreenLayout} from './components/capsulasScreenLayout'

export default CapsulasScreen
